(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/pay-numbergames/assets/javascripts/analytics/track-payment.js') >= 0) return;  svs.modules.push('/components/numbergames/pay-numbergames/assets/javascripts/analytics/track-payment.js');

'use strict';

const _excluded = ["wager"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const currencyFromJupiterString = svs.utils.format.CurrencyFromJupiterString;
const {
  productMapping
} = svs.numbergames;
const bagTypes = svs.numbergames.pay_numbergames.data.bagTypes;
const getBoards = bet => bet.extNumberBoards || bet.lottoBoards || bet.kenoBoards || bet.jokerBoards;
function quickpick(bet) {
  const enums = {
    manual: {
      number: 0
    },
    quickpick: {
      text: 'QUICKPICK',
      number: 1
    },
    partialQP: {
      text: 'PARTIALQP',
      number: 4
    }
  };
  const boards = getBoards(bet);
  if (boards.every(b => b.boardProps.includes(enums.quickpick.text))) {
    return enums.quickpick.number;
  }
  if (boards.every(b => !b.boardProps.includes(enums.quickpick.text) && !b.boardProps.includes(enums.partialQP.text))) {
    return enums.manual.number;
  }
  return enums.partialQP.number;
}
function bag(wager) {
  if (wager.bagType) {
    const bagType = bagTypes.find(b => b.bagType === wager.bagType);
    if (bagType) {
      return {
        bag: "".concat(bagType.size, ":").concat(bagType.productId.toLowerCase(), " ").concat(bagType.size)
      };
    }
  }
}
function system(bet) {
  const boards = getBoards(bet);
  if (boards[0].systemType.includes('MSYS')) {
    const board = boards[0];
    let system;
    if (board.boardData) {
      system = "".concat(board.boardData.length);
    } else {
      system = "".concat(board.boardData1.length, ",").concat(board.boardData2.length);
    }
    return {
      system
    };
  }
}
function isProlongation(bet) {
  return bet.betProperties.includes('PROLONGATION');
}
function prolong(bet) {
  return {
    prolong: isProlongation(bet) ? '1' : '0'
  };
}
async function getFund(product) {
  switch (productMapping.getProductId(product)) {
    case productMapping.CONSTANTS.LOTTO:
    case productMapping.CONSTANTS.EUROJACKPOT:
    case productMapping.CONSTANTS.VIKINGLOTTO:
      return await svs.numbergames.draws.asyncJackpotApi.jackpotAmount(product);
    default:
      return undefined;
  }
}
function singleRow(bet, wager) {
  const isSystem = system(bet);
  const isBag = bag(wager);
  if (!isSystem && !isBag) {
    return {
      singleRow: getBoards(bet).length.toString()
    };
  }
}
function kungkeno(bet) {
  if (productMapping.isKeno(bet.productId) && parseInt(bet.betAmountSalesGroup2, 10) > 0) {
    return {
      kungkeno: true
    };
  }
}
function syndicateName(isSyndicate, syndicate) {
  if (isSyndicate && syndicate && syndicate.syndicateName) {
    return {
      syndicate: syndicate.syndicateName
    };
  }
}
function gameType(wager) {
  const bet = wager.bets[0];
  let gameType = 'enkelrader';
  if (isProlongation(bet)) {
    gameType = 'förlängspel';
  } else if (bag(bet)) {
    gameType = 'färdigaspel';
  } else if (system(bet)) {
    gameType = 'systemspel';
  }
  return {
    gameType
  };
}
async function formatItems(wager, syndicate, isSyndicate, product) {
  const items = [];
  const fund = await getFund(product);
  wager.bets.forEach(bet => {
    const item = {
      productId: bet.productId,
      productName: productMapping.getProductDayName(bet.productId),
      price: currencyFromJupiterString(bet.betAmountSalesGroup1),
      variation: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
        quickpick: quickpick(bet),
        rounds: bet.numDraws,
        fund
      }, kungkeno(bet)), bag(wager)), system(bet)), prolong(bet)), singleRow(bet, wager)), syndicateName(isSyndicate, syndicate))
    };
    switch (productMapping.getProductId(bet.productId)) {
      case productMapping.CONSTANTS.LOTTO:
        {
          const productName = productMapping.getProductName(bet.productId);
          const day = productMapping.getDay(bet.productId);
          items.push(_objectSpread(_objectSpread({}, item), {}, {
            productName: "".concat(productName, " 1 ").concat(day)
          }));
          if (parseInt(bet.betAmountSalesGroup2, 10)) {
            items.push(_objectSpread(_objectSpread({}, item), {}, {
              productName: "".concat(productName, " 2 ").concat(day)
            }));
          }
          break;
        }
      case productMapping.CONSTANTS.KENO:
        items.push(_objectSpread(_objectSpread({}, item), {}, {
          price: item.price + currencyFromJupiterString(bet.betAmountSalesGroup2)
        }));
        break;
      default:
        items.push(item);
    }
  });
  return items;
}
function createTransaction(_ref) {
  let {
    product,
    items,
    wagerClientSerial,
    wagerAmounts
  } = _ref;
  items = items.map(it => new svs.components.analytics.transactionItem(it.productId, it.productName, it.price, 1, it.variation));
  const price = currencyFromJupiterString(wagerAmounts.betAmount);
  return new svs.components.analytics.transaction(wagerClientSerial, price, items, 0, 0, undefined, productMapping.getProductName(product));
}
async function trackPayment(_ref2) {
  let {
    next,
    product,
    successfulWagers,
    syndicate,
    isSyndicate
  } = _ref2;
  successfulWagers.forEach(async _ref3 => {
    let {
        wager
      } = _ref3,
      args = _objectWithoutProperties(_ref3, _excluded);
    const items = await formatItems(wager, syndicate, isSyndicate, product);
    const trans = createTransaction(_objectSpread({
      product,
      items
    }, args));
    const gameAccount = isSyndicate ? 'lag saldo' : 'mitt saldo';
    const options = _objectSpread(_objectSpread({}, gameType(wager)), {}, {
      gameAccount
    });
    svs.components.analytics.trackTransaction(trans, options);
    svs.numbergames.pay_numbergames.logger.debug('Track transaction', trans);
  });
  next();
}
svs.numbergames.pay_numbergames.trackPayment = trackPayment;

 })(window);